module.exports = __webpack_public_path__ + "img/LineUp_Logo_Animado.964d363a.gif";